module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./Oauth2View.js"));
	}, "Oauth2");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=Oauth2!./src/pages/Oauth2/Oauth2View.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=Oauth2!./src/pages/Oauth2/Oauth2View.js
// module chunks = 43